export interface OrganizationErrorBody {
    code?: string;
    description?: string;
    message?: string;
}

export interface HttpErrorLike {
    status?: number;
    error?: OrganizationErrorBody;
}

const DEFAULT_MSG = 'Error inesperado';

const STATUS_MESSAGES: Record<number, string> = {
    400: 'Solicitud inválida. Revisa los datos enviados.',
    401: 'No autorizado. Inicia sesión o verifica tus permisos.',
    404: 'No encontrado. El recurso solicitado no existe.',
    409: 'Conflicto. No se pudo completar la operación (por ejemplo, un nombre ya existe).',
    429: 'Demasiadas solicitudes. Espera un momento e intenta de nuevo.',
    500: 'Error interno del servidor. Intenta más tarde.',
};

function getBodyMessage(body: OrganizationErrorBody | undefined): string | undefined {
    if (!body || typeof body !== 'object') return undefined;
    const text = body.description ?? body.message;
    return typeof text === 'string' && text.trim().length > 0 ? text.trim() : undefined;
}

export function mapOrganizationErrorToMessage(err: HttpErrorLike | unknown): string {
    const status = (err as HttpErrorLike)?.status;
    const body = (err as HttpErrorLike)?.error;
    const bodyMsg = getBodyMessage(body);

    if (status != null && STATUS_MESSAGES[status]) {
        if (status === 400 || status === 409) {
            if (bodyMsg && bodyMsg.length <= 200) {
                return bodyMsg;
            }
        }
        return STATUS_MESSAGES[status];
    }

    if (bodyMsg && bodyMsg.length <= 200) {
        return bodyMsg;
    }

    return DEFAULT_MSG;
}
